/**
 * 用地详情
 */
 import estateTip from "@/components/promotion/information.vue";
 import { createChartDom, removeChartDom } from "../pulgin/createPulgin";
 import { addChartsOverlay, cleanChartsOverlay } from "../pulgin/addChartOverlayPulgin";
 import { convertVueToHtml } from "../pulgin/createPulgin";
 
 export default class urbanIandscapeCharts {
     constructor() {
     }
 
     //用地详情的tip框
     showMapTip(center,data,routerData) {
         removeChartDom()//先清除
         let vm = convertVueToHtml(estateTip, {  info: data,routerData:routerData })
             let html = createChartDom(vm);
             cleanChartsOverlay()
             addChartsOverlay(html, center,'top-right')
     }
 
 }